export const roleList = ['Super', 'Admin', 'Owner', 'User'];
export const capabilityList = ['Owner', 'Admin', 'Player'];
